import type WebSocket from 'ws';
import type { LogFn } from '../../log.js';
import { safeCloseWebSocket } from '../cli-ws-client.js';
import { BRIDGE_HEARTBEAT_MISSED_ACKS_BEFORE_RECONNECT } from './constants.js';

/** Returns true when the tick should stop (socket closed for reconnect). */
export function handlePendingHeartbeatMiss(params: {
  awaitingSeq: number | null;
  missed: number;
  log: LogFn;
  ws: WebSocket;
  onReconnect: () => void;
}): { missed: number; stopTick: boolean } {
  const { awaitingSeq, missed, log, ws, onReconnect } = params;
  if (awaitingSeq === null) return { missed, stopTick: false };

  const nextMissed = missed + 1;
  if (nextMissed < BRIDGE_HEARTBEAT_MISSED_ACKS_BEFORE_RECONNECT) {
    return { missed: nextMissed, stopTick: false };
  }

  try {
    log('[Bridge service] Heartbeat missed repeatedly; reconnecting…');
  } catch {
    /* ignore */
  }
  onReconnect();
  safeCloseWebSocket(ws);
  return { missed: 0, stopTick: true };
}
